function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircledChevronLight = function SvgCircledChevronLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 42 42"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20,
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#13b7d3",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 13.9 7.1 7.1-7.1 7.1",
    style: {
      fill: "none",
      stroke: "#13b7d3",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
};
export default SvgCircledChevronLight;